// @flow
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import FlightCard from './FlightCard';
import { WhitePanel } from '../../../../components';
import { getTotalHoneyguideCredit } from '../../helpers';
import { BookFlightsButton, injectFlightSearchParams } from '../../Common';

type Props = {
  bestInbound: any,
  bestOutbound: any,
  isOneWay: boolean,
  sessionId: null | string,
};

const getOrNull = (data: any) => (key: string) =>
  isEmpty(data) ? null : data[0][key];

const BestOption = (props: Props) => {
  const {
    bestInbound,
    bestOutbound,
    isOneWay,
    isRoundTrip,
    allFlightsSectionId,
    alternativeOptions,
    sessionId,
  } = props;

  const getBestInboundOrNull = getOrNull(bestInbound);
  const getBestOutboundOrNull = getOrNull(bestOutbound);

  const inboundPrice = getBestInboundOrNull('totalAmount');
  const outboundPrice = getBestOutboundOrNull('totalAmount');

  const flightId = getBestOutboundOrNull('flightId');
  const returnFlightId = getBestInboundOrNull('flightId');

  const totalHoneyguideCredit = getTotalHoneyguideCredit(
    bestInbound ? bestInbound[0] : null,
    bestOutbound ? bestOutbound[0] : null
  );

  const totalAmount: number | null =
    Number(outboundPrice) + Number(inboundPrice);

  const flightReadyToBook = isOneWay
    ? Boolean(flightId)
    : Boolean(flightId) && Boolean(returnFlightId);

  const flightsFor = bestOutbound && bestOutbound[0]? `(${fullName(bestOutbound[0].departure)} - ${fullName(bestOutbound[0].arrival)})` : '';

  // Don't show anything if there are no alternative flights
  if (alternativeOptions && !bestOutbound) return null;
  
  return (
    <WhitePanel>
      <h2 className="flight__best__option_title text-center">{alternativeOptions ? `BEST ALTERNATIVE OPTIONS ${flightsFor}` : `BEST OPTION ${flightsFor}`}</h2>
      <Row>
        <Col lg={isOneWay ? '10' : '5'} sm="12">
          <h3 className="flight-result-title text-center">DEPARTURE</h3>
          {bestOutbound ? (
            bestOutbound.map(f => (
              <FlightCard
                flight={f}
                key={f.flightId}
                type="outbound"
                showSelectedButton={false}
                isSelected
              />
            ))
          ) : (
            <p className="error mt-4 text-center">
              Sorry, no departuring flights found. Please select another date
            </p>
          )}
        </Col>
        {isRoundTrip && (
          <Col lg="5" sm="12">
            <h3 className="flight-result-title text-center">RETURN</h3>
            <React.Fragment>
              {bestInbound
                ? bestInbound.map(f => (
                    <FlightCard
                      flight={f}
                      key={f.flightId}
                      type="inbound"
                      showSelectedButton={false}
                      isSelected
                    />
                  ))
                : isRoundTrip && (
                    <p className="error mt-4 text-center">
                      Sorry, no returning flights found. Please select another
                      date
                    </p>
                  )}
            </React.Fragment>
          </Col>
        )}
        {flightReadyToBook && (
          <Col lg="2" sm="12">
            <h5 className="flight__departure mb-0 invisible">Book Now</h5>
            <BookFlightsButton
              totalAmount={totalAmount}
              flightId={flightId}
              returnFlightId={returnFlightId}
              currency={bestOutbound[0].currency}
              extraClass={true}
              honeyguideCredit={totalHoneyguideCredit}
              sessionId={sessionId}
            />
          </Col>
        )}
      </Row>
       <div className="text-center pt-2">
        <a href={`#${allFlightsSectionId}`}>See All Options</a>
       </div>
    </WhitePanel>
  );
};

function fullName(flightsFor){
  if (flightsFor === 'KTM') return "KATHMANDU";
  if (flightsFor === 'LUA') return "LUKLA";
  if (flightsFor === 'RHP') return "RAMECHHAP";
  if (flightsFor === 'PKR') return "POKHARA";
  if (flightsFor === 'JOM') return "JOMSOM";
  return flightsFor;
}

const mapStateToProps = ({ flights: { inbound, outbound, sessionId } }) => ({
  // since the flights in the redux state in sorted by departure time.
  // the best option for the trekkers would be the earliest flights.
  // which is in the first index of the inbound and outbound array.
  sessionId,
  bestInbound: isEmpty(inbound) ? null : [inbound[0]],
  bestOutbound: isEmpty(outbound) ? null : [outbound[0]],
  allFlightsSectionId: 'allFlightsSearchResults',
});

export default connect(mapStateToProps)(injectFlightSearchParams(BestOption));


const mapStateToPropsForAlternativeFlights = ({ flights: { alternativeFlights: { inbound, outbound, sessionId } }}) => ({
  sessionId,
  alternativeOptions: true,
  bestInbound: isEmpty(inbound) ? null : [inbound[0]],
  bestOutbound: isEmpty(outbound) ? null : [outbound[0]],
  allFlightsSectionId: 'allAlternativeFlightsSearchResults',
});

export const BestAlternativeOptions = connect(mapStateToPropsForAlternativeFlights)(injectFlightSearchParams(BestOption));



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchResults/BestOption.js